import React, { useEffect, useState } from "react";
import { Container, Image } from "react-bootstrap";
import HlsPlayer from "../hlsplayer/HlsPlayer";
import "../topPan/toppan.css";
import { Weather } from "../weather/Weather";
// export const TopPan = (props) => {

export const TopPan = ({ video, category, weatherUrl }) => {
  //  const show = video ?? category?.videos?.[0]; // 👈 fallback to category video
  //#if (!show) return null;
  console.log(category);

  const [videos, setVideos] = useState(video || []);

  //const [selectedVideo, setSelectedVideo] = useState(''); // default first
  // const [overlayOpen, setOverlayOpen] = useState(false);

  useEffect(() => {
    fetch(`https://dispatch.whizti.com/api/category/${category.id}`)
      .then((response) => response.json())
      .then((json) => {
        setVideos(json.response.content[0]);
      });
  }, [category.id]);
  useEffect(() => {
    setVideos(video || []);
  }, [video]);
  return (
    <Container fluid className="mb-3">
      {/* <h1 className="mb-4">🚀 Welcome to React-Bootstrap</h1>
        <Button variant="primary" size="lg">Click Me</Button> */}

      <div className="row gx-0">
        <div className="col-md-6">
          <Weather weatherUrl={weatherUrl} />
          <div style={{ position: "relative", width: "100%" }}>
            <Image
              src={videos.icon_uri}
              style={{ width: "100%", objectFit: "cover" }}
            />

            {/* Shadow Overlay */}
            <img
              src="/OTT_shadow.png"
              alt="Shadow overlay"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                objectFit: "cover",
                // pointerEvents: "none", // so clicks still pass through
              }}
            />
          </div>

          <div className="top-title">Currently Playing: {videos.title}</div>
        </div>
        {/* <div className="col-md-2"></div> */}
        <div className="col-md-6">
          {videos.uri ? (
            <HlsPlayer src={videos.uri} autoPlay firstVideo={true} controls />
          ) : (
            <p>Loading video...</p>
          )}
        </div>
      </div>
    </Container>
  );
};
